import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import 'flickity-imagesloaded';

const selectors = {
  slider: '[data-slider]',
};

const sectionType = 'shop-the-story';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;

      const slider = container.querySelector(selectors.slider);
      if (!slider) return;

      // eslint-disable-next-line no-unused-vars
      const flickity = new Flickity(slider, {
        freeScroll: false,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        groupCells: true,
        watchCSS: true,
        contain: true,
      });
    },
  });
